import { BannerModel } from "@/types/BannerModel";
import clsx from "clsx";
import StaticDegradeImage from "./StaticComponents/StaticDegradeImage";

export default function FeatureBanner({
  props,
  className,
}: {
  props: BannerModel;
  className: string;
}) {
  return (
    <>
      <div className={clsx("max-w-4xl", className)}>
        <h1 className="mb-6 font-display tracking-tight text-gray-900 xsmall:text-3xl lg:text-6xl">
          {props.title}
        </h1>
        <p className="mt-6 text-lg leading-8 text-gray-600">
          {props.description}
        </p>
      </div>
      {props.image && (
        <StaticDegradeImage className={className} props={props.image} />
      )}
    </>
  );
}
